// https://developer.twitter.com/en/docs/twitter-for-websites/tweet-button/overview

import React, { useCallback, useEffect, useState } from 'react';
import window from 'window-or-global';

import { Twitter as IconTwitter } from 'react-feather';

interface Props {
  text: string;
  url?: string; // by default - window.location.href
  via?: string;
  // children?: JSX.Element | string;
  shouldOpenWindow?: boolean;
  size?: number;
  className?: string;
}

const openWindowProps =
  'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600';

export const TwitterShareButton = ({
  via = 'Vasyl_Zubach',
  // children,
  shouldOpenWindow = true,
  className,
  size = 16,
  url: propsUrl,
  ...props
}: Props) => {
  const [url, setUrl] = useState(propsUrl ? encodeURIComponent(propsUrl) : '');

  const text = encodeURIComponent(props.text);
  // const url = encodeURIComponent(props.url || window?.location?.href);
  let link = `https://twitter.com/share?url=${url}&text=${text}`;

  if (via) {
    link = `${link}&via=${via}`;
  }

  const openWindow = useCallback(
    (event) => {
      event.preventDefault();
      window.open(link, '', openWindowProps);
    },
    [link]
  );

  useEffect(() => {
    if (!propsUrl) {
      setUrl(window.location.href);
    }
  }, [propsUrl]);

  return (
    <a
      {...props}
      href={link}
      className={className}
      target="_blank"
      rel="nofollow noreferrer"
      onClick={shouldOpenWindow ? openWindow : undefined}
    >
      <IconTwitter width={size} height={size} />
    </a>
  );
};
